<script>
/** Mixin for config pages */

import { cloneDeep, isEqual } from 'lodash';

export default {

  data() {
    return {
      company: null,
    };
  },

  computed: {
    stateCompany() {
      return this.$store.state.config.company;
    },
  },

  watch: {
    stateCompany: {
      deep: true,
      handler(nv, ov) {
        if (!isEqual(nv, ov)) {
          this.mixinCompanyUpdated();
        }
      },
    },
  },

  created() {
    this.mixinCompanyUpdated();
  },

  methods: {
    mixinCompanyUpdated() {
      if (this.stateCompany && this.$store.getters.currentJwt && this.$store.getters.currentJwt.length) {
        this.company = cloneDeep(this.stateCompany);
        this.company.logoWhiteBg = Number(this.company.logoWhiteBg);
        this.company.chartColor = Number(this.company.chartColor);
        if (this.refresh) {
          this.refresh();
        }
      }
    },
  },
};
</script>
